import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/avoirs';

// Créer un nouvel avoir
export const createAvoir = async (avoirData) => {
  const response = await axios.post(API_URL, avoirData);
  return response.data;
};

// Lister tous les avoirs
export const fetchAvoirs = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

// Récupérer un avoir par ID
export const fetchAvoirById = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`);
  return response.data;
};

// Mettre à jour un avoir
export const updateAvoir = async (id, avoirData) => {
  const response = await axios.put(`${API_URL}/${id}`, avoirData);
  return response.data;
};

// Supprimer un avoir
export const deleteAvoir = async (id) => {
  await axios.delete(`${API_URL}/${id}`);
};
